module.exports = __webpack_public_path__ + "img/intelligent_info_process.ac867b55.png";